import { FLOAT, FLOATING_POINT, INTEGER } from '../@type/global';
import { regexFieldCheck } from './regexConfig';

export const omitEmptyValues = <T extends object>(data: T): Partial<T> => {
  const cleaned: Partial<T> = {};
  Object.entries(data).forEach(([key, value]) => {
    if (value !== '' && value !== null) {
      cleaned[key as keyof T] = value as T[keyof T];
    }
  });
  return cleaned;
};

const checkPrices = (type: string, value: string): void => {
  if (!regexFieldCheck(type, value)) {
    throw new Error('Price is invalid');
  }
};

export const convertValue = (type: string, value: string): number | string => {
  switch (type) {
    case INTEGER:
      return Number(value);
    case FLOAT:
      return Number(value);
    case FLOATING_POINT:
      return Number(value);
    default:
      return value;
  }
};

export const checkAndConvert = (type: string, value: string): number => {
  checkPrices(type, value);
  switch (type) {
    case INTEGER:
      return Number(value);
    case FLOAT:
      return Number(value);
    case 'FLOATING_POINT':
      return Number(value);
    case 'INTEGER':
      return Number(value);
    default:
      throw new Error(`Unsupported type: ${type}`);
  }
};

export const isValidIndex = <T>(index: number, array: T[]): boolean => {
  return index >= 0 && index < array.length;
};
